/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DayOfWeek} from './DayOfWeek';
import {Holiday} from './Holiday';
import {diplomatObjectSchema} from './diplomat-object';
import {DiplomatObjectType} from './DiplomatObjectType';

export const HolidayCalendar = diplomatObjectSchema.shape({
   objectType: diplomatObjectSchema.fields.objectType.default(
      DiplomatObjectType.enum.HOLIDAY_CALENDAR
   ),
   nonBusinessDays: yup.array().of(DayOfWeek),
   holidays: yup.array().of(Holiday),
   description: yup.string(),
});
export type IHolidayCalendar = yup.InferType<typeof HolidayCalendar>;
